/** `walkthroughs` namespace catalog (ADR 0368 Phase 3) — the guided-walkthrough player chrome. */
export const messages = {
  walkLoadFailedTitle: "Could not load your walkthroughs",
  walkLoadFailedBody: "We can’t tell which walkthroughs exist. This is not a report that you have none.",
  narrating: 'Walkthrough',
  pause: 'Pause',
  resume: 'Resume',
  stop: 'Stop walkthrough',
  waitingUser: 'Your turn',
  didIt: 'I did it',
  stepOf: 'Step {{n}}',
  stepOfTotal: 'Step {{n}} of {{m}}',
  stepsToggle: 'Steps',
  stepsClose: 'Hide',
  statsButton: 'Stats',
  funnelStarted: '{{n}} started',
  funnelCompleted: '{{n}} completed',
  funnelAbandoned: '{{n}} abandoned',
  funnelStalls: 'Stalls: {{list}}',
  funnelWindowHint: 'Recent runs only — bounded by run retention.',
  funnelSkipped: '{{n}} skipped',
  funnelSkips: 'Skipped: {{list}}',
  funnelWindowScanned: 'Of the last {{n}} runs in this workspace — bounded by run retention.',
  funnelError: 'Couldn’t load stats — try again.',
  stepsPanelTitle: 'Walkthrough steps',
  checkpointBadge: 'Check',
  skippedBadge: 'Already done',
  skippedReason: 'Skipped: {{because}}',
  skippedToast: 'Skipped a step — {{because}}',
  recordCopyStubs: 'Copy {{n}} stub',
  recordCopyStubs_other: 'Copy {{n}} stubs',
  recordCopyStubsTitle: 'Copy registerWalkthroughAction stubs for the steps that have no registered action yet',
  recordStubsCopied: 'Copied {{n}} registration stub to the clipboard.',
  recordStubsCopied_other: 'Copied {{n}} registration stubs to the clipboard.',
  recordStubsCopyFailed: 'Could not copy — the clipboard is unavailable here.',
  needsUpdateTitle: 'This walkthrough needs an update',
  needsUpdateBody: 'A step referenced a part of the app that has moved. The walkthrough was stopped — nothing else was changed.',
  completedToast: 'Walkthrough complete',
  failedToast: 'The walkthrough stopped early.',
  overlayLabel: 'Walkthrough player',
  csWalkthroughNewBrief: 'First, open a new brief — the container for product, persona, and channels.',
  chatWalkthroughCompose: 'Your turn: type a message and press Send.',
  agentsWalkthroughRoster: 'This is the agent roster — each tile is a standing agent with its status and role.',
  boardsWalkthrough: 'The kanban board — drag cards between columns to move work along.',
  workforcesWalkthrough: 'The workforces gallery — each card is a team of agents you can hire.',
  inboxWalkthrough: 'Your inbox — notifications and approvals land here.',
  projectsWalkthrough: 'Your projects — each one groups work, docs, and chat.',
  agentTemplatesWalkthrough: 'Agent templates — start a new agent from a proven persona.',
  rosterWalkthrough: 'The org chart — how your agents report and collaborate.',
  mediaWalkthrough: 'The media library — every uploaded asset, searchable.',
  cmsWalkthrough: 'Your CMS pages — draft, publish, and localize content here.',
  publishingWalkthrough: 'Publishing settings — domains and where your content goes live.',
  promptsWalkthrough: 'The prompt library — governed, reusable prompts for your agents.',
  memoryWalkthrough: 'The memory ledger — what your agents remember, inspectable.',
  capabilitiesWalkthrough: 'The capabilities panel — what this host advertises and honors.',
  cliWalkthrough: 'The CLI quickstart — drive the app from your terminal.',
  featureTogglesWalkthrough: 'Feature toggles — turn features on for your workspace here.',
  orgsWalkthrough: 'Your workspaces — organizations, members, and roles.',
  usersWalkthrough: 'Members — who has access and at what level.',
  connectionsWalkthrough: 'Connections — link outside providers to your workspace.',
  exampleDataWalkthrough: 'Example data — seed a demo workspace to explore safely.',
  funnelsWalkthroughList: 'Your sales funnels — create one here, then assemble its steps from your CMS pages.',
  commerceWalkthroughCatalog: 'Your product catalog — create the product your funnel sells, then price it here.',
  modelsWalkthroughHub: 'The Models hub — choose which models power your chat and agents.',
  workflowsWalkthroughDashboard: 'The workflows dashboard — your saved and draft workflows live here.',
  runsWalkthroughIndex: 'The run history — every workflow execution, with its status.',
  keysWalkthroughProviders: 'Provider keys — connect your own model credentials here (BYOK).',
  keysWalkthroughAlreadyConfigured: 'Checking whether you have already connected a provider…',
  chatWalkthroughResponse: 'Watch the assistant\u2019s reply stream in.',
  csWalkthroughNameBrief: 'Your turn: name the brief. Tip: start it with “[Walkthrough]” so it’s easy to find and clean up.',
  csWalkthroughCreate: 'Create the brief.',
  csWalkthroughCheckpoint: 'Checking the brief was created…',
  csWalkthroughCampaignsTab: 'Finally, the Campaigns tab is where a confirmed brief becomes a running campaign.',
  recording: 'Recording',
  stepsCaptured: '{{n}} steps',
  recordNamePlaceholder: 'Name this walkthrough…',
  recordNameLabel: 'Walkthrough name',
  recordSave: 'Save walkthrough',
  recordCancel: 'Cancel',
  recordOverlayLabel: 'Walkthrough recorder',
  recordSaved: 'Walkthrough saved as a draft — review and run it once to publish.',
  recordSavedNeedsWork: 'Saved, but some steps need a registered action before it can run.',
  recordSaveFailed: 'Couldn’t save the walkthrough — try again.',
  recordBusy: 'Finish or stop the running walkthrough before recording.',
  recordEnrich: 'Enrich with AI',
  recordEnrichTitle: 'Hand this recording to the assistant to write narration + refine it',
  recordEnrichUnnamed: 'this flow',
  recordEnrichPrompt: 'Turn this recording into a polished walkthrough named "{{name}}" using the walkthroughs.register-draft tool. Write a short, friendly narration for each step, mark typing/upload steps as hitl, and add a checkpoint after any step that creates or changes data. Steps:\n{{steps}}',
  pageEyebrow: 'Authoring',
  pageTitle: 'Guided walkthroughs',
  pageLede: 'Record a click-through, review it, and play it back — the same durable workflow engine as your tests.',
  recordWalkthrough: 'Record a walkthrough',
  play: 'Play',
  yourWalkthroughsTitle: 'Your walkthroughs',
  yourWalkthroughsHint: 'Walkthroughs you recorded, authored, or loaded from example data.',
  noWalkthroughsTitle: 'No walkthroughs yet',
  noWalkthroughsBody: 'Press “Record a walkthrough” to capture a flow — or load the samples from Example data.',
  loadSamples: 'Load example walkthroughs',
  removeWalkthrough: 'Remove',
  removeError: 'Couldn’t remove that walkthrough — try again.',
  draftChip: 'Draft',
  savedChip: 'Published',
  stepCount: '{{n}} steps',
  reviewInBuilder: 'Review',
  loadError: 'Couldn’t load your walkthroughs.',
  disabledBody: 'Walkthroughs are off. Enable the Walkthroughs feature to record and play walkthroughs.',
};
